module.exports = __webpack_public_path__ + "media/Video07_aggressive.83d5d824.mp4";